<script setup>
import SvgIcon from '@/components/base/SvgIcon.vue';
const emit = defineEmits(['googleVerify']);
const parseJwt = (token) => {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(
        atob(base64)
            .split('')
            .map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join('')
    );
    return JSON.parse(jsonPayload);
};
const handleCredentialResponse = (response) => {
    const thirdPartyData = parseJwt(response.credential);
    console.log(JSON.stringify(thirdPartyData.sub));
    window.localStorage.setItem('from-third-party-id', thirdPartyData.sub);
    window.localStorage.setItem('from-third-party-type', '1');
    emit('googleVerify', response.credential);
};
onMounted(() => {
    window.google.accounts.id.initialize({
        client_id: import.meta.env.VITE_GOOGLE_CLIENTID,
        callback: handleCredentialResponse,
        context: 'signin'
    });
    //建立登入按鈕
    window.google.accounts.id.renderButton(document.getElementById('google-sign-in-button'), {
        type: 'icon',
        shape: 'pill',
        size: 'large'
    });
});
</script>
<template>
    <div class="google-btn">
        <SvgIcon style="width: 32px; height: 32px" name="google" />
        <div id="google-sign-in-button"></div>
    </div>
</template>

<style lang="scss" scoped>
.google-btn {
    position: relative;

    .svg-icon {
        position: absolute;
    }

    #google-sign-in-button {
        opacity: 0;
        @include wh(32);
    }
}
</style>
